/* This file is autogenerated, see readme.md for instructions */
import FullscreenSvgIcon from '@bloomreach/banana-theme/icons/fullscreen.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FullscreenIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FullscreenSvgIcon />
    </Icon>
  );
});

FullscreenIcon.displayName = 'FullscreenIcon';

export default FullscreenIcon;
